import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { c as classNames } from "../../index-CweZ_OcN.js";
import { useState } from "react";
import { Text } from "../Text/index.es.js";
import "../Icon/index.es.js";
import { IconChevronDown } from "../icons/IconChevronDown/index.es.js";
import { IconChevronUp } from "../icons/IconChevronUp/index.es.js";
import { Conditional } from "../Conditional/index.es.js";
import './styles.css';const NavbarVertical = ({
  data,
  renderItem,
  renderActions
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "au-navbar-vertical", children: [
    data == null ? void 0 : data.map((link, idx) => {
      return renderItem(link, idx);
    }),
    /* @__PURE__ */ jsx("div", { className: "au-navbar-vertical__actions", children: renderActions() })
  ] });
};
const NavbarVerticalLink = ({
  name,
  onClick,
  Icon,
  dropdown,
  href,
  active = false
}) => {
  const [open, setOpen] = useState(active);
  function handleClick(ev) {
    if (dropdown) {
      setOpen((prev) => !prev);
    } else if (onClick) {
      ev.preventDefault();
      onClick();
    }
  }
  return /* @__PURE__ */ jsxs(
    Text,
    {
      as: dropdown ? "p" : "a",
      href,
      variant: "heading-micro",
      weight: "light",
      className: classNames("au-navbar-vertical__link", {
        [`au-navbar-vertical__link--is-active`]: active,
        [`au-navbar-vertical__link--is-open`]: open
      }),
      onClick: handleClick,
      children: [
        /* @__PURE__ */ jsx(Conditional, { condition: !!Icon, renderIf: Icon }),
        name,
        /* @__PURE__ */ jsx(
          Conditional,
          {
            condition: !!(dropdown == null ? void 0 : dropdown.length),
            renderIf: /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Conditional, { condition: !!open, renderIf: /* @__PURE__ */ jsx(IconChevronUp, {}) }),
              /* @__PURE__ */ jsx(Conditional, { condition: !open, renderIf: /* @__PURE__ */ jsx(IconChevronDown, {}) }),
              /* @__PURE__ */ jsx("div", { className: "au-navbar-vertical__dropdown", children: dropdown == null ? void 0 : dropdown.map((item, idx) => {
                return /* @__PURE__ */ jsx(
                  Text,
                  {
                    as: "a",
                    href: item.href,
                    variant: "heading-micro",
                    weight: "light",
                    className: classNames("au-navbar-vertical__dropdown-link", {
                      "au-navbar-vertical__dropdown-link--is-active": item.active
                    }),
                    title: item.name,
                    onClick: item.onClick,
                    children: item.name
                  },
                  `${item.name}-${idx}`
                );
              }) })
            ] })
          }
        )
      ]
    }
  );
};
NavbarVertical.Link = NavbarVerticalLink;
export {
  NavbarVertical
};
//# sourceMappingURL=index.es.js.map
